/**
 * orga-app-api - api-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UploadResponse { 
    upload_id: string;
    user_id: string;
    file_name: string;
    content_type?: string;
    upload_date_utc: Date;
    folder_name?: string;
}

